import { Sprite } from 'three';

import { createBadgeSprite } from '../marker-sprites';

/** `userData.type` of the container group holding every marker. */
export const VALIDATION_MARKER_GROUP_TYPE = 'validation-markers';
/** `userData.type` of one marker sprite — a hit target, so the raycaster must not skip it. */
export const VALIDATION_MARKER_TYPE = 'validation-marker';

export type ValidationMarkerSeverity = 'info' | 'warn' | 'error' | 'critical';

/** Scene units (inches) across the badge */
export const VALIDATION_MARKER_SIZE = 9;

const FILL: Record<ValidationMarkerSeverity, string> = {
	info: '#2f7fe0',
	warn: '#e8921f',
	error: '#d9453a',
	critical: '#a81d14'
};

/**
 * A round severity badge that always faces the camera: the exclamation alone for a
 * single validation, the count when several sit on the same appliance.
 */
export const createValidationMarkerSprite = (severity: ValidationMarkerSeverity, count: number): Sprite => createBadgeSprite({
	label: count > 1 ? String(count) : '!',
	fill: FILL[severity] ?? FILL.warn,
	size: VALIDATION_MARKER_SIZE,
	renderOrder: 998
});

/** The worst of several severities — the badge takes its colour from it. */
export const worstSeverity = (severities: Array<ValidationMarkerSeverity>): ValidationMarkerSeverity => {
	const order: Array<ValidationMarkerSeverity> = ['info', 'warn', 'error', 'critical'];
	return severities.reduce((worst, next) => (order.indexOf(next) > order.indexOf(worst) ? next : worst), 'info');
};
